import { BaSeFooter } from '@base/react';
import * as React from 'react';
import { ContainerFooter, FooterWrapper } from './footer-candidate-styled';

export const LayoutFooterCandidate = () => {

  return (
    <ContainerFooter>
      <FooterWrapper>
        <BaSeFooter
          delimitedOnBreakpoint="desktop"
          systemName="Empretec"
          systemVersion={process.env.REACT_APP_VERSION}
          backgroundColor="white"
          hideLinks={true}
        />
      </FooterWrapper>
    </ContainerFooter>
  );
};
